import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output
} from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Store } from '@ngrx/store';
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged, takeWhile } from 'rxjs/operators';
@Component({
  selector: 'app-form-input',
  templateUrl: './form-input.component.html',
  styleUrls: ['./form-input.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FormInputComponent implements OnInit, OnDestroy {
  @Input() form: FormGroup;
  @Input() field;

  @Input() showLabel = true;

  @Output()
  edit = new EventEmitter();

  _alive = true;
  _paramChange$ = new Subject<any>();
  // countryDepartments$ = this.store.pipe(select(fromCountryDepartments.getAll));
  countryDepartmentRed;
  get label() {
    const required = this.field && this.field.required ? ' *' : '';
    return this.field && this.field.label + required;
  }

  get type() {
    return this.field && this.field.type;
  }

  get fieldName() {
    return this.field && this.field.fieldName;
  }

  get valueKey() {
    return this.field && this.field.valueKey;
  }

  get displayKey() {
    return this.field && this.field.displayKey;
  }

  get search() {
    return this.field && this.field.search;
  }

  get items$() {
    return this.field && this.field.items$;
  }

  get hasError() {
    return (
      this.form &&
      this.field &&
      this.form.get(this.field.fieldName) &&
      !this.form.get(this.field.fieldName).valid &&
      (this.form.get(this.field.fieldName).dirty ||
        this.form.get(this.field.fieldName).touched)
    );
  }

  constructor(private store: Store<any>) {}

  ngOnInit() {
    this._paramChange$
      .pipe(
        debounceTime(200),
        distinctUntilChanged(),
        takeWhile(() => this._alive)
      )
      .subscribe(change => this.edit.emit(change));

    if (this.field && this.field.items$) {
      this.field.items$.subscribe(cd => {
        if (cd) {
          this.countryDepartmentRed = cd.reduce((acc, item) => {
            acc[item.id] = item;

            return acc;
          }, {});
        }
      });
    }
  }

  ngOnDestroy() {
    this._alive = false;
  }

  buildNestedProp(desc, value) {
    const obj = {};
    const [key, ...arr] = desc.split('.');
    if (arr && arr.length) {
      return { [key]: this.buildNestedProp(arr.join('.'), value) };
    } else {
      obj[key] = value;
      return obj;
    }
  }

  changedParam(e, param) {
    let value = null;
    if(e === undefined){
      e = null
    }
    if (this.type === 'select') {
      value = e;
    } else {
      value = e.target && e.target.value;

      if (!value) {
        value = e.item;
      }
    }

    if (this.type === 'integer') {
      try {
        value = parseInt(value, 10);
      } catch (e) {
        value = 0;
      }
    } else if (this.type === 'float') {
      try {
        value = parseFloat(value);
      } catch (e) {
        value = 0;
      }
    } else if (this.type === 'number') {
      console.warn(
        `Field '${this.fieldName}' declared as ${
          this.type
        }. Please specify if it's an integer or float. Default: float`
      );
      try {
        value = parseFloat(value).toFixed(2);
      } catch (e) {
        value = 0;
      }
    }
    // console.log(e, ' - ',param)
    this._paramChange$.next(this.buildNestedProp(param, value));
  }

  isVoltage(id) {
    if (id === 'voltage') {
      return true;
    } else {
      return false;
    }
  }

  //countryName(id) {
  //return this.countryNameRed[id];
  //}

  optionsTrackFn(index, item) {
    //console.log(item)
    return item.id;
  }

  searchItem(item) {
    console.log(item);
  }

  name(id) {
    console.log('id', id);
  }
}
